import { PicoAppEnum } from "jadro-pico/apps/PicoAppEnum.ts";
import { ThemeIconEnum } from "../Themes/ThemeEnums";

export const picoAppIconMap: Record<PicoAppEnum, ThemeIconEnum> = {
  [PicoAppEnum.PICO_COM]: ThemeIconEnum.HOME,
  [PicoAppEnum.CHLAST_PICO]: ThemeIconEnum.LOCAL_BAR,
  [PicoAppEnum.KUKANA_PICO]: ThemeIconEnum.BUILD,
  [PicoAppEnum.SIPKY_PICO]: ThemeIconEnum.SPORTS_ESPORTS,
  [PicoAppEnum.BEERRALLY_PICO]: ThemeIconEnum.SPORTS_BAR,
  [PicoAppEnum.KDESU_PICO]: ThemeIconEnum.MAP,
  [PicoAppEnum.SKLADKA_PICO]: ThemeIconEnum.WAREHOUSE,
};
